/*
 * @Date: 2025-03-31 13:07:59
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-10-13 00:23:54
 */

import axios from "axios";
import { API_CONFIG } from "../config/api";

const instance = axios.create(API_CONFIG);

// 请求拦截器
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器
instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      console.error("API Error:", error.response.status, error.response.data);
    }
    return Promise.reject(error);
  }
);

export default instance;
